module.exports = __webpack_public_path__ + "images/internal/review_widgets/content_type/video.svg";